import { render, staticRenderFns } from "./LiquidacionDetail.vue?vue&type=template&id=c5ded13a&scoped=true&"
import script from "./LiquidacionDetail.vue?vue&type=script&lang=js&"
export * from "./LiquidacionDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionDetail.vue?vue&type=style&index=0&id=c5ded13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ded13a",
  null
  
)

export default component.exports